/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Backend_Development_Api_Desc3Inputs */

const en_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints, schemas, and contracts designed before implementation, APIs that frontend teams actually like consuming.`)
};

const ar_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقاط نهاية ومخططات وعقود مصممة قبل التنفيذ، واجهات برمجية تستمتع فرق الواجهة الأمامية باستخدامها فعلًا.`)
};

const bn_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইমপ্লিমেন্টেশনের আগে ডিজাইন করা এন্ডপয়েন্ট, স্কিমা ও কন্ট্রাক্ট, API যা ফ্রন্টএন্ড টিম আসলে পছন্দ করে ব্যবহার করতে।`)
};

const de_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpunkte, Schemata und Verträge, die vor der Implementierung entworfen wurden, APIs, die Frontend-Teams tatsächlich gerne nutzen.`)
};

const es_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints, esquemas y contratos diseñados antes de implementar, APIs que a los equipos frontend les gusta consumir.`)
};

const fr_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints, schémas et contrats conçus avant l'implémentation, des APIs que les équipes frontend aiment vraiment consommer.`)
};

const pt_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoints, esquemas e contratos projetados antes da implementação, APIs que as equipes de front-end realmente gostam de usar.`)
};

const zh_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`实现之前先设计好端点、结构和契约，做前端团队真正爱用的 API。`)
};

const tr_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulamadan önce tasarlanan endpoint'ler, şemalar ve sözleşmeler, frontend ekiplerinin gerçekten kullanmayı sevdiği API'ler.`)
};

const ru_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эндпоинты, схемы и контракты, спроектированные до реализации,, API, которые фронтенд-командам правда нравится использовать.`)
};

const pl_svc_backend_development_api_desc3 = /** @type {(inputs: Svc_Backend_Development_Api_Desc3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpointy, schematy i kontrakty zaprojektowane przed implementacją, API, które zespoły frontendowe naprawdę lubią używać.`)
};

/**
* | output |
* | --- |
* | "Endpoints, schemas, and contracts designed before implementation, APIs that frontend teams actually like consuming." |
*
* @param {Svc_Backend_Development_Api_Desc3Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_backend_development_api_desc3 = /** @type {((inputs?: Svc_Backend_Development_Api_Desc3Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Backend_Development_Api_Desc3Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_backend_development_api_desc3(inputs)
	if (locale === "bn") return bn_svc_backend_development_api_desc3(inputs)
	if (locale === "de") return de_svc_backend_development_api_desc3(inputs)
	if (locale === "es") return es_svc_backend_development_api_desc3(inputs)
	if (locale === "fr") return fr_svc_backend_development_api_desc3(inputs)
	if (locale === "pt") return pt_svc_backend_development_api_desc3(inputs)
	if (locale === "zh") return zh_svc_backend_development_api_desc3(inputs)
	if (locale === "tr") return tr_svc_backend_development_api_desc3(inputs)
	if (locale === "ru") return ru_svc_backend_development_api_desc3(inputs)
	if (locale === "pl") return pl_svc_backend_development_api_desc3(inputs)
	return en_svc_backend_development_api_desc3(inputs)
});
export { svc_backend_development_api_desc3 as "svc_backend-development_API_desc" }